/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SigintSignal, SigintSignal$inboundSchema } from "./sigintsignal.js";

export type ListSigintSignalsResult = {
  /**
   * Final returned signal ID when another page exists
   */
  nextCursor?: string | undefined;
  /**
   * Signals in this page
   */
  signals: Array<SigintSignal>;
};

/** @internal */
export const ListSigintSignalsResult$inboundSchema: z.ZodMiniType<
  ListSigintSignalsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    signals: z.array(SigintSignal$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSigintSignalsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSigintSignalsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSigintSignalsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSigintSignalsResult' from JSON`,
  );
}
